// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TokenCount{box-sizing:border-box;background:rgba(74,74,74,.5);width:fit-content;padding:4px 8px;border-radius:8px}.TokenCount__icon{position:relative;vertical-align:middle}.TokenCount__icon path{fill:#fff}.TokenCount__number{vertical-align:middle;margin-left:8px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
